'use client';

import { useMutation } from '@tanstack/react-query';
import { PAYMENT_MUTATIONS } from '../../infrastructure/payment/utils/queries';

export const usePaymentService = () => {
  const useCreatePaymentIntent = () => {
    return useMutation(PAYMENT_MUTATIONS.createPaymentIntent());
  };

  const useUpdatePaymentIntent = () => {
    return useMutation(PAYMENT_MUTATIONS.updatePaymentIntent());
  };

  const useCreatePaypalOrder = () => {
    return useMutation(PAYMENT_MUTATIONS.createPaypalOrder());
  };

  const useCapturePaypalOrder = () => {
    return useMutation(PAYMENT_MUTATIONS.capturePaypalOrder());
  };

  const useRecoverPaypalOrder = () => {
    return useMutation(PAYMENT_MUTATIONS.recoverPaypalOrder());
  };

  const useAcknowledgePaypalRecovery = () => {
    return useMutation(PAYMENT_MUTATIONS.acknowledgePaypalRecovery());
  };

  return {
    useCreatePaymentIntent,
    useUpdatePaymentIntent,
    useCreatePaypalOrder,
    useCapturePaypalOrder,
    useRecoverPaypalOrder,
    useAcknowledgePaypalRecovery,
  };
};
